import { SELECT_LOOKUP, HIDDEN } from '../InputTypes';

export const fields = [
  'QualificationTypeName',
  'QualificationName',
  'HrQualificationScaleEntryName',
];

export const detailFields = [
  ...fields,
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  EmployeeMasterQualificationID: {
    type: HIDDEN,
  },
  QualificationType: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrQualificationType?$filter=Disabled eq false',
      value: 'HrQualificationTypeID',
      label: 'HrQualificationTypeName',
    },
  },
  HrQualificationID: {
    allowAddOption: true,
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrQualification?$filter=Disabled eq false',
      link: 'HrQualificationTypeID',
      lookupValue: 'QualificationType',
      value: 'HrQualificationID',
      label: 'HrQualificationName',
      number: true,
    },
    link: {
      entity: 'HrQualification?$filter=Disabled eq false',
      linkValue: 'HrQualificationID',
      value: 'HrQualificationScaleID',
    },
  },
  HrQualificationScaleEntryID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrQualificationScaleEntry',
      link: 'HrQualificationScaleID',
      lookupValue: 'HrQualificationScaleID',
      value: 'HrQualificationScaleEntryID',
      label: 'HrQualificationScaleEntryName',
      number: true,
      orderByValue: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterQualification.js